module.exports = __webpack_public_path__ + "img/btn_google_signin_dark_pressed_web@2x.75a7cb04.png";